import {inject, Injectable} from '@angular/core';
import {EventEmitterService} from './event-emitter.service';
import {HttpErrorResponse} from '@angular/common/http';
import {AxiosError} from 'axios';

const INVALID_TOKEN_STATUS = 'ACCESS_DENIED_INVALID_TOKEN';

@Injectable({
  providedIn: 'root',
})
export class TokenErrorHandlerService {
  eventEmitterService = inject(EventEmitterService);

  processHttpError(errorResponseData: HttpErrorResponse | AxiosError): void {
    let status: number | undefined;

    if (errorResponseData instanceof HttpErrorResponse) {
      status = errorResponseData.status;
    } else if (errorResponseData instanceof AxiosError) {
      status = errorResponseData.response?.status;
    }

    if (status === 401) {
      return this.eventEmitterService.handleExpiredToken.next(false);
    }

    if (status === 403) {
      this.eventEmitterService.showForbiddenDialog.next(true);
    }
  }
}
